export const myTimesheetTranslationsEn = {
  MY_TIMESHEET_ADMIN_GUIDE: "MyTimesheet administrator manual",
  MY_TIMESHEET_VIEWER_GUIDE: "MyTimesheet viewer manual",
  MY_TIMESHEET_EXAMINER_GUIDE: "MyTimesheet examiner manual",
  MY_TIMESHEET_USER_GUIDE: "MyTimesheet user manual",
  MY_TIMESHEET_COST_VALUE_REQUIRED: "Cost is required!",
  MY_TIMESHEET_DURATION_EXCEEDS_LIMIT: "The duration exceeds the maximum value of 12 hours!",
  MY_TIMESHEET_RECORDING_ACTIVITIES_NOT_ALLOWED: "Recording activities is not allowed for this day!",
  MY_TIMESHEET_COST_UPDATE_FAILED: "Cost update failed!",
  MY_TIMESHEET_COST_SUCCESSFUL_UPDATED: "Cost successfully updated",
  MY_TIMESHEET_NEW_COST_CREATE_FAILED: "Create cost failed!",
  MY_TIMESHEET_NEW_COST_SUCCESSFUL_CREATED: "Cost successfully created",
  MY_TIMESHEET_CLIENT_UPDATE_FAILED: "Client update failed!",
  MY_TIMESHEET_CLIENT_SUCCESSFUL_UPDATED: "Client successfully updated",
  MY_TIMESHEET_NEW_CLIENT_CREATE_FAILED: "Create client failed!",
  MY_TIMESHEET_NEW_CLIENT_SUCCESSFUL_CREATED: "Client successfully created",
  MY_TIMESHEET_PROJECT_UPDATE_FAILED: "Project update failed!",
  MY_TIMESHEET_PROJECT_SUCCESSFUL_UPDATED: "Project successfully updated",
  MY_TIMESHEET_DETAILS: "Details",
  MY_TIMESHEET_SELECT_COLOR: "Select color",
  MY_TIMESHEET_EDIT_COST: "Edit cost",
  MY_TIMESHEET_EDIT_CLIENT: "Edit client",
  MY_TIMESHEET_EDIT_PROJECT: "Edit project",
  MY_TIMESHEET_NEW_CLIENT: "New client",
  MY_TIMESHEET_CLIENT_NAME: "Client name",
  MY_TIMESHEET_COST_NAME: "Cost name",
  MY_TIMESHEET_NEW_COST: "New cost",
  MY_TIMESHEET_BILLABLE_COST: "Billable cost",
  MY_TIMESHEET_SAVE_NEW_PROJECT_TEXT: "A worker can add a new project if there is no project in the list that she wants to use.",
  MY_TIMESHEET_SAVE_NEW_PROJECT: "Save new project",
  MY_TIMESHEET_NO_WORKING_TIME_REPORT_DATA: "There are no recording work hours at the specified time!",
  MY_TIMESHEET_EXAMINER_VIEW: "Examiners",
  MY_TIMESHEET_VIEWER_VIEW: "Viewers",
  MY_TIMESHEET_SUCCESSFUL_REJECTED: "Time entry successfully rejected!",
  MY_TIMESHEET_REJECT_FAILED: "Time entry reject failed!",
  MY_TIMESHEET_MONDAY: "Monday",
  MY_TIMESHEET_TUESDAY: "Tuesday",
  MY_TIMESHEET_WEDNESDAY: "Wednesday",
  MY_TIMESHEET_THURSDAY: "Thursday",
  MY_TIMESHEET_FRIDAY: "Friday",
  MY_TIMESHEET_SATURDAY: "Saturday",
  MY_TIMESHEET_SUNDAY: "Sunday",
  MY_TIMESHEET_WEEK: "Week",
  MY_TIMESHEET_WORKTIME_REPORT: "Worktime report",
  MY_TIMESHEET_WORKTIME_SUMMARY: "Worktime summary",
  MY_TIMESHEET_OWN_WORKIME: "Own worktime",
  MY_TIMESHEET_REQUESTED_DURATION: "Requested duration",
  MY_TIMESHEET_REQUESTED_COST: "Requested cost",
  MY_TIMESHEET_REQUESTS: "My time sheet requests",
  MY_TIMESHEET_REVOKE_REQUEST: "Revoke request",
  MY_TIMESHEET_DESCRIPTION_TOO_LONG: "The description is too long!",
  MY_TIMESHEET_NAME_TOO_LONG: "Name too long!",
  MY_TIMESHEET_NAME_ALREADY_EXISTS: "This name is already in use",
  MY_TIMESHEET_NEW_PROJECT_CREATE_FAILED: "Create project failed!",
  MY_TIMESHEET_NEW_PROJECT_SUCCESSFUL_CREATED: "Project successfully created",
  MY_TIMESHEET_PROJECT_NAME: "Project designation",
  MY_TIMESHEET_NEW_PROJECT: "New project",
  MY_TIMESHEET_UPDATE_FAILED: "Time entry update failed!",
  MY_TIMESHEET_SUCCESSFUL_UPDATED: "Time entry successfully updated",
  MY_TIMESHEET_CREATE_FAILED: "Time entry creation failed!",
  MY_TIMESHEET_SUCCESSFUL_CREATED: "Time entry successfully created",
  MY_TIMESHEET_REMOVAL_FAILED: "Time entry withdrawn failed!",
  MY_TIMESHEET_SUCCESSFUL_REMOVED: "Time entry successfully withdrawn",
  MY_TIMESHEET_MINUTE: "Minute(s)",
  MY_TIMESHEET_SUMMARY: "Timesheet summary",
  MY_TIMESHEET_COST_SUMMARY: "Cost summary",
  MY_TIMESHEET_CLIENT_SUMMARY: "Client summary",
  MY_TIMESHEET_PROJECT_SUMMARY: "Project summary",
  MY_TIMESHEET_TOTAL_COST: "Total cost",
  MY_TIMESHEET_TOTAL_TIME_BILLABLE: "Total time (billable)",
  MY_TIMESHEET_TOTAL_TIME: "Total time",
  MY_TIMESHEET_CREATE: "Create",
  MY_TIMESHEET_SEND_APPROVAL: "Send approval",
  MY_TIMESHEET_EDIT_ACTIVITY: "Edit activity",
  MY_TIMESHEET_WORKTIME: "Worktime",
  MY_TIMESHEET_ADD_NEW_PROJECT: "Add new project",
  MY_TIMESHEET_ACTIVITY_REQUEST: "Activity request",
  MY_TIMESHEET_WEEK_TOTAL: "Weekly total",
  MY_TIMESHEET_NEW_ACTIVITY: "New activity",
  MY_TIMESHEET_ACTIVITIES: "Activities",
  MY_TIMESHEET_ACTIVITY_RECORD: "Activity record",
  MY_TIMESHEET_END_OF_WORK: "End of work",
  MY_TIMESHEET_DAILY_TOTAL: "Daily total",
  MY_TIMESHEET_CLOCK_IN: "Clock in",
  MY_TIMESHEET_THIS_WEEK: "This week",
  MY_TIMESHEET_LAST_WEEK: "Last week",
  MY_TIMESHEET_ADD_TIMESHEET: "Add timesheet",
  MY_TIMESHEET_WORK_TIME_DASHBOARD_WEEKLY: "Weekly work time dashboard",
  MY_TIMESHEET_DURATION: "Duration",
  MY_TIMESHEET_CLIENT: "Client",
  MY_TIMESHEET_SUMMARY_STATEMENT: "Summary",
  MY_TIMESHEET_PROJECT: "Project",
  MY_TIMESHEET_TOTAL_WORK_HOURS_TODAY: "Total work hours today",
  MY_TIMESHEET_TIMESHEET: "Timesheet",
  MY_TIMESHEET_TIME_TRACKER: "Time recorder",
  MY_TIMESHEET_MONTHLY: "Monthly",
  MY_TIMESHEET_WEEKLY: "Weekly",
  MY_TIMESHEET_TIMESHEET_REPORT: "Performance Certificate",
  MY_TIMESHEET_DAILY_BREAKDOWN: "Daily Breakdown",
  MY_TIMESHEET_ACTIVITY: "Activity",
  MY_TIMESHEET_START: "Start",
  MY_TIMESHEET_END: "End",
  MY_TIMESHEET_BREAKDOWN: "Breakdown",
  MY_TIMESHEET_EMPLOYEE_SIGNATURE: "Employee Signature",
  MY_TIMESHEET_MANAGER_SIGNATURE: "Manager Signature",
  MY_TIMESHEET_TIMESHEET_REPORT_PRINT: "Print timesheet",
  MY_TIMESHEET_TOTAL_DURATION: "Total Duration",
  MY_TIMESHEET_PERFORMER_SIGNATURE: "Performer",
  MY_TIMESHEET_CERTIFIER_SIGNATURE: "Certifier",
};
